/* unplugin-vue-components disabled */import { render } from "./sources-inline.vue?vue&type=template&id=6a4a7d8c&scoped=true"
import script from "./sources-inline.vue?vue&type=script&lang=js"
export * from "./sources-inline.vue?vue&type=script&lang=js"

import "./sources-inline.vue?vue&type=style&index=0&id=6a4a7d8c&lang=stylus"
import "./sources-inline.vue?vue&type=style&index=1&id=6a4a7d8c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4a7d8c"],['__file',"src/components/sources-v2/sources-inline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a4a7d8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a4a7d8c', __exports__)) {
    api.reload('6a4a7d8c', __exports__)
  }
  
  module.hot.accept("./sources-inline.vue?vue&type=template&id=6a4a7d8c&scoped=true", () => {
    api.rerender('6a4a7d8c', render)
  })

}


export default __exports__